/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AssignUsersToPopulation } from '@coin/shared/core/util-models-v2';
import { ChartPermission } from '@coin/shared/core/util-models-v2';
import { CreateChartPermission } from '@coin/shared/core/util-models-v2';
import { CreateJobAssignmentRecord } from '@coin/shared/core/util-models-v2';
import { CreateManyOrganisationChartRecords } from '@coin/shared/core/util-models-v2';
import { CreateOrganisation } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationChart } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationRecord } from '@coin/shared/core/util-models-v2';
import { CreatePermissionSetting } from '@coin/shared/core/util-models-v2';
import { CreatePopulation } from '@coin/shared/core/util-models-v2';
import { CreatePositionRecord } from '@coin/shared/core/util-models-v2';
import { CreateSimulationPermission } from '@coin/shared/core/util-models-v2';
import { DeleteManyEmployeeRecords } from '@coin/shared/core/util-models-v2';
import { DeleteManyOrganisationRecords } from '@coin/shared/core/util-models-v2';
import { DeleteManyPositionRecords } from '@coin/shared/core/util-models-v2';
import { DeletedOrganisationRecord } from '@coin/shared/core/util-models-v2';
import { DuplicateOrganisationChart } from '@coin/shared/core/util-models-v2';
import { EmployeePositionRecord } from '@coin/shared/core/util-models-v2';
import { EntitySearchScope } from '@coin/shared/core/util-models-v2';
import { JobAssignmentRecord } from '@coin/shared/core/util-models-v2';
import { MoveManyOrganisationRecords } from '@coin/shared/core/util-models-v2';
import { MoveManyOrganisations } from '@coin/shared/core/util-models-v2';
import { MoveManyPositionRecords } from '@coin/shared/core/util-models-v2';
import { MoveOrganisation } from '@coin/shared/core/util-models-v2';
import { MoveOrganisationRecord } from '@coin/shared/core/util-models-v2';
import { OrgPlanningMasterDataExport } from '@coin/shared/core/util-models-v2';
import { OrganisationChart } from '@coin/shared/core/util-models-v2';
import { OrganisationChartRecord } from '@coin/shared/core/util-models-v2';
import { OrganisationPlanningOrganisationsOrganisation } from '@coin/shared/core/util-models-v2';
import { OrganisationPlanningSimulationsCreateSimulation } from '@coin/shared/core/util-models-v2';
import { OrganisationPlanningSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { OrganisationPlanningSimulationsUpdateSimulation } from '@coin/shared/core/util-models-v2';
import { OrganisationRecord } from '@coin/shared/core/util-models-v2';
import { OrganisationRecordCount } from '@coin/shared/core/util-models-v2';
import { OrganisationRecordOrigin } from '@coin/shared/core/util-models-v2';
import { PageOfChartPermission } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeePositionRecord } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeRecordSearchResult } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationChart } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationChartRecord } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationPlanningSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { PageOfPermissionSetting } from '@coin/shared/core/util-models-v2';
import { PageOfPopulation } from '@coin/shared/core/util-models-v2';
import { PageOfSimulationPermission } from '@coin/shared/core/util-models-v2';
import { PageOfSimulationSettings } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PermissionSetting } from '@coin/shared/core/util-models-v2';
import { Population } from '@coin/shared/core/util-models-v2';
import { PopulationsUpdatePopulation } from '@coin/shared/core/util-models-v2';
import { PositionRecord } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SimulationPermission } from '@coin/shared/core/util-models-v2';
import { SimulationSettings } from '@coin/shared/core/util-models-v2';
import { SimulationsPublishSimulation } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfDeleteOrganisationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfDuplicateMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMoveOrganisationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMovePositionMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPermissionRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationUserAssignmentMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPublishingMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfUpdateOrganisationMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateJobAssignmentRecord } from '@coin/shared/core/util-models-v2';
import { UpdateManyOrganisationChartRecords } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisation } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationChart } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationRecord } from '@coin/shared/core/util-models-v2';
import { UpdatePermissionSetting } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRecord } from '@coin/shared/core/util-models-v2';
import { UpdateSimulationSettings } from '@coin/shared/core/util-models-v2';
import { UserPopulation } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AssignPopulationUsersParams {
  populationId: string;
  simulationId: string;
  assignUsersToPopulation?: AssignUsersToPopulation;
}

export interface CreateChartPermissionsParams {
  chartId: string;
  createChartPermission?: CreateChartPermission;
}

export interface CreateManyOrganisationChartRecordsParams {
  simulationId: string;
  createManyOrganisationChartRecords?: CreateManyOrganisationChartRecords;
}

export interface CreateOrganisationChartsParams {
  createOrganisationChart?: CreateOrganisationChart;
}

export interface CreateOrganisationsParams {
  chartId: string;
  createOrganisation?: CreateOrganisation;
}

export interface CreatePermissionSettingsParams {
  simulationId: string;
  createPermissionSetting?: CreatePermissionSetting;
}

export interface CreatePopulationsParams {
  simulationId: string;
  createPopulation?: CreatePopulation;
}

export interface CreateSimulationPermissionsParams {
  simulationId: string;
  createSimulationPermission?: CreateSimulationPermission;
}

export interface CreateSimulationsParams {
  organisationPlanningSimulationsCreateSimulation?: OrganisationPlanningSimulationsCreateSimulation;
}

export interface DeleteChartPermissionsParams {
  chartId: string;
  userId: string;
}

export interface DeleteOrganisationChartsParams {
  chartId: string;
}

export interface DeletePermissionSettingsParams {
  id: string;
  simulationId: string;
}

export interface DeletePopulationsParams {
  id: string;
  simulationId: string;
}

export interface DeleteSimulationPermissionsParams {
  simulationId: string;
  userId: string;
}

export interface DeleteSimulationsParams {
  simulationId: string;
}

export interface DuplicateOrganisationChartsParams {
  chartId: string;
  duplicateOrganisationChart?: DuplicateOrganisationChart;
}

export interface ExportEmployeesChartExportParams {
  chartId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface ExportEmployeesSimulationExportParams {
  simulationId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface ExportOrganisationsChartExportParams {
  chartId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface ExportOrganisationsSimulationExportParams {
  simulationId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface ExportPositionsChartExportParams {
  chartId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface ExportPositionsSimulationExportParams {
  simulationId: string;
  orgPlanningMasterDataExport?: OrgPlanningMasterDataExport;
}

export interface GetPopulationUsersParams {
  populationId: string;
  simulationId: string;
}

export interface GetPopulationsParams {
  id: string;
  simulationId: string;
}

export interface GetScopeEmployeeRecordsParams {
  simulationId: string;
}

export interface MoveManyOrganisationsParams {
  chartId: string;
  moveManyOrganisations?: MoveManyOrganisations;
}

export interface MoveOrganisationsParams {
  id: string;
  chartId: string;
  moveOrganisation?: MoveOrganisation;
}

export interface MovePositionRecordsParams {
  simulationId: string;
  moveManyPositionRecords?: MoveManyPositionRecords;
}

export interface OrganisationPlanningAdminCreateJobAssignmentRecordsParams {
  simulationId: string;
  createJobAssignmentRecord?: CreateJobAssignmentRecord;
}

export interface OrganisationPlanningAdminCreateOrganisationRecordsParams {
  simulationId: string;
  createOrganisationRecord?: CreateOrganisationRecord;
}

export interface OrganisationPlanningAdminCreatePositionRecordsParams {
  simulationId: string;
  createPositionRecord?: CreatePositionRecord;
}

export interface OrganisationPlanningAdminDeleteJobAssignmentRecordsParams {
  id: string;
  simulationId: string;
}

export interface OrganisationPlanningAdminDeleteManyEmployeeRecordsParams {
  simulationId: string;
  deleteManyEmployeeRecords?: DeleteManyEmployeeRecords;
}

export interface OrganisationPlanningAdminDeleteManyOrganisationRecordsParams {
  simulationId: string;
  deleteManyOrganisationRecords?: DeleteManyOrganisationRecords;
}

export interface OrganisationPlanningAdminDeleteManyPositionRecordsParams {
  simulationId: string;
  deleteManyPositionRecords?: DeleteManyPositionRecords;
}

export interface OrganisationPlanningAdminDeleteOrganisationRecordsParams {
  id: string;
  simulationId: string;
}

export interface OrganisationPlanningAdminDeleteOrganisationsParams {
  id: string;
  chartId: string;
}

export interface OrganisationPlanningAdminDeletePositionRecordsParams {
  id: string;
  simulationId: string;
}

export interface OrganisationPlanningAdminGetOrganisationChartRecordsParams {
  simulationId: string;
  id: string;
}

export interface OrganisationPlanningAdminGetOrganisationChartsParams {
  chartId: string;
}

export interface OrganisationPlanningAdminGetOrganisationRecordsParams {
  id: string;
  simulationId: string;
}

export interface OrganisationPlanningAdminGetOrganisationsParams {
  id: string;
  chartId: string;
}

export interface OrganisationPlanningAdminGetSimulationSettingsParams {
  simulationId: string;
  id: string;
}

export interface OrganisationPlanningAdminGetSimulationsParams {
  simulationId: string;
}

export interface OrganisationPlanningAdminMoveManyOrganisationRecordsParams {
  simulationId: string;
  moveManyOrganisationRecords?: MoveManyOrganisationRecords;
}

export interface OrganisationPlanningAdminMoveOrganisationRecordsParams {
  id: string;
  simulationId: string;
  moveOrganisationRecord?: MoveOrganisationRecord;
}

export interface OrganisationPlanningAdminQueryCountsOrganisationRecordsParams {
  simulationId: string;
  /** The unique id of the organisation chart for the organisation record query. */
  organisationChartId: string;
  /** The parent org code for the organisation record query. */
  parentOrgCode: string;
  /** The depth for the organisation record query. */
  depth?: number;
}

export interface OrganisationPlanningAdminQueryDeletedOrganisationRecordsParams {
  simulationId: string;
  /** The unique id of the organisation chart for the organisation record query. */
  organisationChartId: string;
  /** The parent org code for the organisation record query. */
  parentOrgCode: string;
  /** The depth for the organisation record query. */
  depth?: number;
}

export interface OrganisationPlanningAdminQueryEmployeeRecordsParams {
  simulationId: string;
  /** The unique id of the organisation for the job assignment deviation query. */
  organisationId?: string;
  /** The unique id of the organisation chart for the job assignment deviation query. */
  organisationChartId?: string;
  /** The unique id of the origin organisation chart for the job assignment deviation query. */
  originOrganisationChartId?: string;
  /** The gid for the job assignment deviation query. */
  gid?: string;
  /** The last name for the job assignment deviation query. */
  lastname?: string;
  /** The first name for the job assignment deviation query. */
  firstname?: string;
  /** The organisation code for the job assignment deviation query. */
  orgCode?: string;
  /** The gids for the job assignment deviation query. */
  gids?: Array<string>;
  /** The organisation codes for the job assignment deviation query. */
  orgCodes?: Array<string>;
  /** The places of action for the job assignment deviation query. */
  placesOfAction?: Array<string>;
  /** The assignment states for the job assignment deviation query. */
  assignmentStates?: Array<'NoAssignment' | 'MultiplePrimaryAssignments' | 'OnlySecondaryAssignments'>;
  /** The search string for the job assignment deviation query. */
  search?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface OrganisationPlanningAdminQueryFieldValuesOrganisationRecordsParams {
  simulationId: string;
  /** The unique id of the organisation chart for the organisation record query. */
  organisationChartId: string;
  /** The target property for the organisation record query. */
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  /** The organisation code for the organisation record query. */
  orgCode?: string;
  /** The type of the organisation for the organisation record query. */
  orgType?: string;
  /** The class of the organisation for the organisation record query. */
  orgClass?: string;
  /** The unit of the organisation for the organisation record query. */
  orgUnit?: string;
  /** The min level of the organisation for the organisation record query. */
  orgLevel?: number;
  /** The levels of the organisation for the organisation record query. */
  orgLevels?: Array<number>;
  page?: number;
  size?: number;
}

export interface OrganisationPlanningAdminQueryFieldValuesOrganisationsParams {
  /** The unique id of the organisation chart for the organisation query. */
  organisationChartId: string;
  chartId: string;
  /** The target property for the organisation query. */
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  /** The organisation code for the organisation query. */
  orgCode?: string;
  /** The organisation type for the organisation query. */
  orgType?: string;
  /** The organisation name for the organisation query. */
  orgName?: string;
  /** The organisation unit for the organisation query. */
  orgUnit?: string;
  /** The organisation class for the organisation query. */
  orgClass?: string;
  /** The organisation levels for the organisation query. */
  orgLevels?: Array<number>;
  page?: number;
  size?: number;
}

export interface OrganisationPlanningAdminQueryOrganisationChartRecordsParams {
  simulationId: string;
  page?: number;
  size?: number;
}

export interface OrganisationPlanningAdminQueryOrganisationChartsParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface OrganisationPlanningAdminQueryOrganisationRecordOriginsParams {
  simulationId: string;
  /** The unique id for the organisation chart of the organisation record origin query. */
  organisationChartId: string;
  /** The parent org code for the organisation record origin query. */
  parentOrgCode: string;
  /** The depth for the organisation record origin query. */
  depth?: number;
}

export interface OrganisationPlanningAdminQueryOrganisationRecordsParams {
  simulationId: string;
  /** The unique id of the organisation chart for the organisation record query. */
  organisationChartId: string;
  /** The parent org code for the organisation record query. */
  parentOrgCode: string;
  /** The depth for the organisation record query. */
  depth?: number;
}

export interface OrganisationPlanningAdminQueryOrganisationsParams {
  chartId: string;
  /** The parent org code for the organisation record query. */
  parentOrgCode: string;
  /** The depth for the organisation record query. */
  depth?: number;
}

export interface OrganisationPlanningAdminQueryParentsOrganisationRecordOriginsParams {
  id: string;
  simulationId: string;
  depth?: number;
}

export interface OrganisationPlanningAdminQueryParentsOrganisationRecordsParams {
  id: string;
  simulationId: string;
  depth?: number;
}

export interface OrganisationPlanningAdminQueryPositionRecordsParams {
  simulationId: string;
  /** The unique id of the organisation for the query. */
  organisationId?: string;
  /** The unique id of the organisation chart for the query. */
  organisationChartId?: string;
  /** The title of the position record for the query. */
  title?: string;
  /** The organisation code for the query. */
  orgCode?: string;
  /** The parent organisation code for the query. */
  parentOrgCode?: string;
  /** The array of organisation codes for the query. */
  orgCodes?: Array<string>;
  /** The array of parent organisation codes for the query. */
  parentOrgCodes?: Array<string>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface OrganisationPlanningAdminQuerySimulationSettingsParams {
  simulationId: string;
  page?: number;
  size?: number;
}

export interface OrganisationPlanningAdminQuerySimulationsParams {
  /** The title of the simulation. */
  title?: string;
  /** The simulation state of the simulation. */
  simulationState?:
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData';
  /** Whether the simulation is archived. */
  isArchived?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface OrganisationPlanningAdminUpdateJobAssignmentRecordsParams {
  id: string;
  simulationId: string;
  updateJobAssignmentRecord?: UpdateJobAssignmentRecord;
}

export interface OrganisationPlanningAdminUpdateOrganisationRecordsParams {
  id: string;
  simulationId: string;
  updateOrganisationRecord?: UpdateOrganisationRecord;
}

export interface OrganisationPlanningAdminUpdateOrganisationsParams {
  id: string;
  chartId: string;
  updateOrganisation?: UpdateOrganisation;
}

export interface OrganisationPlanningAdminUpdatePositionRecordsParams {
  id: string;
  simulationId: string;
  updatePositionRecord?: UpdatePositionRecord;
}

export interface PublishSimulationsParams {
  simulationId: string;
  simulationsPublishSimulation?: SimulationsPublishSimulation;
}

export interface QueryAssignedEmployeesJobAssignmentRecordsParams {
  simulationId: string;
  /** The unique id of the organisation for the job assignment record query. */
  organisationId?: string;
  /** The unique id of the organisation chart for the job assignment record query. */
  organisationChartId?: string;
  /** The GID for the job assignment record query. */
  gid?: string;
  /** The last name for the job assignment record query. */
  lastname?: string;
  /** The first name for the job assignment record query. */
  firstname?: string;
  /** The organisation code for the job assignment record query. */
  orgCode?: string;
  /** The GIDs for the job assignment record query. */
  gids?: Array<string>;
  /** The organisation codes for the job assignment record query. */
  orgCodes?: Array<string>;
  /** The search string for the job assignment record query. */
  search?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface QueryChartPermissionsParams {
  chartId: string;
  page?: number;
  size?: number;
}

export interface QueryFieldValuesEmployeeRecordsParams {
  simulationId: string;
  fieldName: string;
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryParentsOrganisationsParams {
  id: string;
  chartId: string;
  depth?: number;
}

export interface QueryPermissionSettingsParams {
  simulationId: string;
  /** The title of the permission setting. */
  title?: string;
  /** The root org code of the permission setting. */
  rootOrgCode?: string;
  /** The root record org code of the permission setting. */
  rootRecordOrgCode?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface QueryPopulationsParams {
  simulationId: string;
  /** Filter populations by title prefix. */
  title?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface QuerySimulationPermissionsParams {
  simulationId: string;
  page?: number;
  size?: number;
}

export interface RecalculateManyPermissionSettingsParams {
  simulationId: string;
}

export interface RecalculateManyPopulationsParams {
  simulationId: string;
}

export interface RecalculatePermissionSettingsParams {
  id: string;
  simulationId: string;
}

export interface RecalculatePopulationsParams {
  id: string;
  simulationId: string;
}

export interface RemovePopulationUsersParams {
  populationId: string;
  userId: string;
  simulationId: string;
}

export interface SimulatePopulationEmployeeRecordsParams {
  simulationId: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  ruleSet?: RuleSet;
}

export interface UpdateManyOrganisationChartRecordsParams {
  simulationId: string;
  updateManyOrganisationChartRecords?: UpdateManyOrganisationChartRecords;
}

export interface UpdateOrganisationChartsParams {
  chartId: string;
  updateOrganisationChart?: UpdateOrganisationChart;
}

export interface UpdatePermissionSettingsParams {
  simulationId: string;
  id: string;
  updatePermissionSetting?: UpdatePermissionSetting;
}

export interface UpdatePopulationsParams {
  simulationId: string;
  id: string;
  populationsUpdatePopulation?: PopulationsUpdatePopulation;
}

export interface UpdateSimulationSettingsParams {
  simulationId: string;
  id: string;
  updateSimulationSettings?: UpdateSimulationSettings;
}

export interface UpdateSimulationsParams {
  simulationId: string;
  organisationPlanningSimulationsUpdateSimulation?: OrganisationPlanningSimulationsUpdateSimulation;
}

@Injectable({
  providedIn: 'root'
})
export class OrganisationPlanningAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignPopulationUsers(
    requestParameters?: AssignPopulationUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationUserAssignmentMetadata>;
  public assignPopulationUsers(
    requestParameters?: AssignPopulationUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationUserAssignmentMetadata>>;
  public assignPopulationUsers(
    requestParameters?: AssignPopulationUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationUserAssignmentMetadata>>;
  public assignPopulationUsers(requestParameters?: AssignPopulationUsersParams, ...args: RequestArgs): Observable<any> {
    const populationId = requestParameters?.populationId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('assignPopulationUsers', { populationId, simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'populationId', value: populationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/users`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.assignUsersToPopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createChartPermissions(
    requestParameters?: CreateChartPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ChartPermission>;
  public createChartPermissions(
    requestParameters?: CreateChartPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ChartPermission>>;
  public createChartPermissions(
    requestParameters?: CreateChartPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ChartPermission>>;
  public createChartPermissions(
    requestParameters?: CreateChartPermissionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('createChartPermissions', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createChartPermission,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManyOrganisationChartRecords(
    requestParameters?: CreateManyOrganisationChartRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public createManyOrganisationChartRecords(
    requestParameters?: CreateManyOrganisationChartRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public createManyOrganisationChartRecords(
    requestParameters?: CreateManyOrganisationChartRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public createManyOrganisationChartRecords(
    requestParameters?: CreateManyOrganisationChartRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createManyOrganisationChartRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-charts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createManyOrganisationChartRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrganisationCharts(
    requestParameters?: CreateOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationChart>;
  public createOrganisationCharts(
    requestParameters?: CreateOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationChart>>;
  public createOrganisationCharts(
    requestParameters?: CreateOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationChart>>;
  public createOrganisationCharts(
    requestParameters?: CreateOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisationChart,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrganisations(
    requestParameters?: CreateOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationPlanningOrganisationsOrganisation>;
  public createOrganisations(
    requestParameters?: CreateOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationPlanningOrganisationsOrganisation>>;
  public createOrganisations(
    requestParameters?: CreateOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationPlanningOrganisationsOrganisation>>;
  public createOrganisations(requestParameters?: CreateOrganisationsParams, ...args: RequestArgs): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('createOrganisations', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPermissionSettings(
    requestParameters?: CreatePermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PermissionSetting>;
  public createPermissionSettings(
    requestParameters?: CreatePermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PermissionSetting>>;
  public createPermissionSettings(
    requestParameters?: CreatePermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PermissionSetting>>;
  public createPermissionSettings(
    requestParameters?: CreatePermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createPermissionSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permission-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPermissionSetting,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPopulations(
    requestParameters?: CreatePopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Population>;
  public createPopulations(
    requestParameters?: CreatePopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Population>>;
  public createPopulations(
    requestParameters?: CreatePopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Population>>;
  public createPopulations(requestParameters?: CreatePopulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createPopulations', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/populations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSimulationPermissions(
    requestParameters?: CreateSimulationPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPermission>;
  public createSimulationPermissions(
    requestParameters?: CreateSimulationPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPermission>>;
  public createSimulationPermissions(
    requestParameters?: CreateSimulationPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPermission>>;
  public createSimulationPermissions(
    requestParameters?: CreateSimulationPermissionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('createSimulationPermissions', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSimulationPermission,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSimulations(
    requestParameters?: CreateSimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationPlanningSimulationsSimulation>;
  public createSimulations(
    requestParameters?: CreateSimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationPlanningSimulationsSimulation>>;
  public createSimulations(
    requestParameters?: CreateSimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationPlanningSimulationsSimulation>>;
  public createSimulations(requestParameters?: CreateSimulationsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.organisationPlanningSimulationsCreateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteChartPermissions(
    requestParameters?: DeleteChartPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteChartPermissions(
    requestParameters?: DeleteChartPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteChartPermissions(
    requestParameters?: DeleteChartPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteChartPermissions(
    requestParameters?: DeleteChartPermissionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    const userId = requestParameters?.userId;
    this.checkRequired('deleteChartPermissions', { chartId, userId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOrganisationCharts(
    requestParameters?: DeleteOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteOrganisationCharts(
    requestParameters?: DeleteOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteOrganisationCharts(
    requestParameters?: DeleteOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteOrganisationCharts(
    requestParameters?: DeleteOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('deleteOrganisationCharts', { chartId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePermissionSettings(
    requestParameters?: DeletePermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deletePermissionSettings(
    requestParameters?: DeletePermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deletePermissionSettings(
    requestParameters?: DeletePermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deletePermissionSettings(
    requestParameters?: DeletePermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('deletePermissionSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/permission-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePopulations(
    requestParameters?: DeletePopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deletePopulations(
    requestParameters?: DeletePopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deletePopulations(
    requestParameters?: DeletePopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deletePopulations(requestParameters?: DeletePopulationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('deletePopulations', { id, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSimulationPermissions(
    requestParameters?: DeleteSimulationPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteSimulationPermissions(
    requestParameters?: DeleteSimulationPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteSimulationPermissions(
    requestParameters?: DeleteSimulationPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteSimulationPermissions(
    requestParameters?: DeleteSimulationPermissionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const userId = requestParameters?.userId;
    this.checkRequired('deleteSimulationPermissions', { simulationId, userId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSimulations(
    requestParameters?: DeleteSimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteSimulations(
    requestParameters?: DeleteSimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteSimulations(
    requestParameters?: DeleteSimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteSimulations(requestParameters?: DeleteSimulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('deleteSimulations', { simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateOrganisationCharts(
    requestParameters?: DuplicateOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDuplicateMetadata>;
  public duplicateOrganisationCharts(
    requestParameters?: DuplicateOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDuplicateMetadata>>;
  public duplicateOrganisationCharts(
    requestParameters?: DuplicateOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDuplicateMetadata>>;
  public duplicateOrganisationCharts(
    requestParameters?: DuplicateOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('duplicateOrganisationCharts', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.duplicateOrganisationChart,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeesChartExport(
    requestParameters?: ExportEmployeesChartExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeesChartExport(
    requestParameters?: ExportEmployeesChartExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesChartExport(
    requestParameters?: ExportEmployeesChartExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesChartExport(
    requestParameters?: ExportEmployeesChartExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('exportEmployeesChartExport', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeesSimulationExport(
    requestParameters?: ExportEmployeesSimulationExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeesSimulationExport(
    requestParameters?: ExportEmployeesSimulationExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesSimulationExport(
    requestParameters?: ExportEmployeesSimulationExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesSimulationExport(
    requestParameters?: ExportEmployeesSimulationExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('exportEmployeesSimulationExport', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOrganisationsChartExport(
    requestParameters?: ExportOrganisationsChartExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportOrganisationsChartExport(
    requestParameters?: ExportOrganisationsChartExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationsChartExport(
    requestParameters?: ExportOrganisationsChartExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationsChartExport(
    requestParameters?: ExportOrganisationsChartExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('exportOrganisationsChartExport', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOrganisationsSimulationExport(
    requestParameters?: ExportOrganisationsSimulationExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportOrganisationsSimulationExport(
    requestParameters?: ExportOrganisationsSimulationExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationsSimulationExport(
    requestParameters?: ExportOrganisationsSimulationExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationsSimulationExport(
    requestParameters?: ExportOrganisationsSimulationExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('exportOrganisationsSimulationExport', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPositionsChartExport(
    requestParameters?: ExportPositionsChartExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPositionsChartExport(
    requestParameters?: ExportPositionsChartExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionsChartExport(
    requestParameters?: ExportPositionsChartExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionsChartExport(
    requestParameters?: ExportPositionsChartExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('exportPositionsChartExport', { chartId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPositionsSimulationExport(
    requestParameters?: ExportPositionsSimulationExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPositionsSimulationExport(
    requestParameters?: ExportPositionsSimulationExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionsSimulationExport(
    requestParameters?: ExportPositionsSimulationExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionsSimulationExport(
    requestParameters?: ExportPositionsSimulationExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('exportPositionsSimulationExport', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.orgPlanningMasterDataExport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPopulationUsers(
    requestParameters?: GetPopulationUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<UserPopulation>>;
  public getPopulationUsers(
    requestParameters?: GetPopulationUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<UserPopulation>>>;
  public getPopulationUsers(
    requestParameters?: GetPopulationUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<UserPopulation>>>;
  public getPopulationUsers(requestParameters?: GetPopulationUsersParams, ...args: RequestArgs): Observable<any> {
    const populationId = requestParameters?.populationId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('getPopulationUsers', { populationId, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'populationId', value: populationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/users`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPopulations(
    requestParameters?: GetPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Population>;
  public getPopulations(
    requestParameters?: GetPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Population>>;
  public getPopulations(
    requestParameters?: GetPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Population>>;
  public getPopulations(requestParameters?: GetPopulationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('getPopulations', { id, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeEmployeeRecords(
    requestParameters?: GetScopeEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EntitySearchScope>;
  public getScopeEmployeeRecords(
    requestParameters?: GetScopeEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EntitySearchScope>>;
  public getScopeEmployeeRecords(
    requestParameters?: GetScopeEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EntitySearchScope>>;
  public getScopeEmployeeRecords(
    requestParameters?: GetScopeEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('getScopeEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/employees/scope`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public moveManyOrganisations(
    requestParameters?: MoveManyOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMoveOrganisationMetadata>;
  public moveManyOrganisations(
    requestParameters?: MoveManyOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMoveOrganisationMetadata>>;
  public moveManyOrganisations(
    requestParameters?: MoveManyOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMoveOrganisationMetadata>>;
  public moveManyOrganisations(requestParameters?: MoveManyOrganisationsParams, ...args: RequestArgs): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('moveManyOrganisations', { chartId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.moveManyOrganisations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public moveOrganisations(
    requestParameters?: MoveOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMoveOrganisationMetadata>;
  public moveOrganisations(
    requestParameters?: MoveOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMoveOrganisationMetadata>>;
  public moveOrganisations(
    requestParameters?: MoveOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMoveOrganisationMetadata>>;
  public moveOrganisations(requestParameters?: MoveOrganisationsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    const chartId = requestParameters?.chartId;
    this.checkRequired('moveOrganisations', { id, chartId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.moveOrganisation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public movePositionRecords(
    requestParameters?: MovePositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMovePositionMetadata>;
  public movePositionRecords(
    requestParameters?: MovePositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMovePositionMetadata>>;
  public movePositionRecords(
    requestParameters?: MovePositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMovePositionMetadata>>;
  public movePositionRecords(requestParameters?: MovePositionRecordsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('movePositionRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.moveManyPositionRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminCreateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminCreateJobAssignmentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAssignmentRecord>;
  public organisationPlanningAdminCreateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminCreateJobAssignmentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAssignmentRecord>>;
  public organisationPlanningAdminCreateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminCreateJobAssignmentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAssignmentRecord>>;
  public organisationPlanningAdminCreateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminCreateJobAssignmentRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminCreateJobAssignmentRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/job-assignments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createJobAssignmentRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminCreateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminCreateOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationRecord>;
  public organisationPlanningAdminCreateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminCreateOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationRecord>>;
  public organisationPlanningAdminCreateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminCreateOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationRecord>>;
  public organisationPlanningAdminCreateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminCreateOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminCreateOrganisationRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisationRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminCreatePositionRecords(
    requestParameters?: OrganisationPlanningAdminCreatePositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeePositionRecord>;
  public organisationPlanningAdminCreatePositionRecords(
    requestParameters?: OrganisationPlanningAdminCreatePositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeePositionRecord>>;
  public organisationPlanningAdminCreatePositionRecords(
    requestParameters?: OrganisationPlanningAdminCreatePositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeePositionRecord>>;
  public organisationPlanningAdminCreatePositionRecords(
    requestParameters?: OrganisationPlanningAdminCreatePositionRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminCreatePositionRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminDeleteJobAssignmentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public organisationPlanningAdminDeleteJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminDeleteJobAssignmentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public organisationPlanningAdminDeleteJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminDeleteJobAssignmentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public organisationPlanningAdminDeleteJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminDeleteJobAssignmentRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeleteJobAssignmentRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/job-assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteManyEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public organisationPlanningAdminDeleteManyEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public organisationPlanningAdminDeleteManyEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public organisationPlanningAdminDeleteManyEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeleteManyEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.deleteManyEmployeeRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDeleteOrganisationMetadata>;
  public organisationPlanningAdminDeleteManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeleteManyOrganisationRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.deleteManyOrganisationRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteManyPositionRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyPositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public organisationPlanningAdminDeleteManyPositionRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyPositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public organisationPlanningAdminDeleteManyPositionRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyPositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public organisationPlanningAdminDeleteManyPositionRecords(
    requestParameters?: OrganisationPlanningAdminDeleteManyPositionRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeleteManyPositionRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.deleteManyPositionRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDeleteOrganisationMetadata>;
  public organisationPlanningAdminDeleteOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeleteOrganisationRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeleteOrganisations(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfDeleteOrganisationMetadata>;
  public organisationPlanningAdminDeleteOrganisations(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteOrganisations(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfDeleteOrganisationMetadata>>;
  public organisationPlanningAdminDeleteOrganisations(
    requestParameters?: OrganisationPlanningAdminDeleteOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const chartId = requestParameters?.chartId;
    this.checkRequired('organisationPlanningAdminDeleteOrganisations', { id, chartId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminDeletePositionRecords(
    requestParameters?: OrganisationPlanningAdminDeletePositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public organisationPlanningAdminDeletePositionRecords(
    requestParameters?: OrganisationPlanningAdminDeletePositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public organisationPlanningAdminDeletePositionRecords(
    requestParameters?: OrganisationPlanningAdminDeletePositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public organisationPlanningAdminDeletePositionRecords(
    requestParameters?: OrganisationPlanningAdminDeletePositionRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminDeletePositionRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/positions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationChartRecord>;
  public organisationPlanningAdminGetOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationChartRecord>>;
  public organisationPlanningAdminGetOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationChartRecord>>;
  public organisationPlanningAdminGetOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('organisationPlanningAdminGetOrganisationChartRecords', { simulationId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-charts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationChart>;
  public organisationPlanningAdminGetOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationChart>>;
  public organisationPlanningAdminGetOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationChart>>;
  public organisationPlanningAdminGetOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminGetOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('organisationPlanningAdminGetOrganisationCharts', { chartId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationRecord>;
  public organisationPlanningAdminGetOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationRecord>>;
  public organisationPlanningAdminGetOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationRecord>>;
  public organisationPlanningAdminGetOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminGetOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminGetOrganisationRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetOrganisations(
    requestParameters?: OrganisationPlanningAdminGetOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationPlanningOrganisationsOrganisation>;
  public organisationPlanningAdminGetOrganisations(
    requestParameters?: OrganisationPlanningAdminGetOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationPlanningOrganisationsOrganisation>>;
  public organisationPlanningAdminGetOrganisations(
    requestParameters?: OrganisationPlanningAdminGetOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationPlanningOrganisationsOrganisation>>;
  public organisationPlanningAdminGetOrganisations(
    requestParameters?: OrganisationPlanningAdminGetOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const chartId = requestParameters?.chartId;
    this.checkRequired('organisationPlanningAdminGetOrganisations', { id, chartId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetSimulationSettings(
    requestParameters?: OrganisationPlanningAdminGetSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationSettings>;
  public organisationPlanningAdminGetSimulationSettings(
    requestParameters?: OrganisationPlanningAdminGetSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationSettings>>;
  public organisationPlanningAdminGetSimulationSettings(
    requestParameters?: OrganisationPlanningAdminGetSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationSettings>>;
  public organisationPlanningAdminGetSimulationSettings(
    requestParameters?: OrganisationPlanningAdminGetSimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('organisationPlanningAdminGetSimulationSettings', { simulationId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminGetSimulations(
    requestParameters?: OrganisationPlanningAdminGetSimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationPlanningSimulationsSimulation>;
  public organisationPlanningAdminGetSimulations(
    requestParameters?: OrganisationPlanningAdminGetSimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationPlanningSimulationsSimulation>>;
  public organisationPlanningAdminGetSimulations(
    requestParameters?: OrganisationPlanningAdminGetSimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationPlanningSimulationsSimulation>>;
  public organisationPlanningAdminGetSimulations(
    requestParameters?: OrganisationPlanningAdminGetSimulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminGetSimulations', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminMoveManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveManyOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMoveOrganisationMetadata>;
  public organisationPlanningAdminMoveManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveManyOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMoveOrganisationMetadata>>;
  public organisationPlanningAdminMoveManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveManyOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMoveOrganisationMetadata>>;
  public organisationPlanningAdminMoveManyOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveManyOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminMoveManyOrganisationRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.moveManyOrganisationRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminMoveOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMoveOrganisationMetadata>;
  public organisationPlanningAdminMoveOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMoveOrganisationMetadata>>;
  public organisationPlanningAdminMoveOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMoveOrganisationMetadata>>;
  public organisationPlanningAdminMoveOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminMoveOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminMoveOrganisationRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.moveOrganisationRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryCountsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryCountsOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationRecordCount>>;
  public organisationPlanningAdminQueryCountsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryCountsOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationRecordCount>>>;
  public organisationPlanningAdminQueryCountsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryCountsOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationRecordCount>>>;
  public organisationPlanningAdminQueryCountsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryCountsOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const organisationChartId = requestParameters?.organisationChartId;
    const parentOrgCode = requestParameters?.parentOrgCode;
    this.checkRequired('organisationPlanningAdminQueryCountsOrganisationRecords', {
      simulationId,
      organisationChartId,
      parentOrgCode
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations/counts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrganisationChartId: organisationChartId, ParentOrgCode: parentOrgCode, Depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryDeletedOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryDeletedOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<DeletedOrganisationRecord>>;
  public organisationPlanningAdminQueryDeletedOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryDeletedOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<DeletedOrganisationRecord>>>;
  public organisationPlanningAdminQueryDeletedOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryDeletedOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<DeletedOrganisationRecord>>>;
  public organisationPlanningAdminQueryDeletedOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryDeletedOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const organisationChartId = requestParameters?.organisationChartId;
    const parentOrgCode = requestParameters?.parentOrgCode;
    this.checkRequired('organisationPlanningAdminQueryDeletedOrganisationRecords', {
      simulationId,
      organisationChartId,
      parentOrgCode
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations/deleted`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrganisationChartId: organisationChartId, ParentOrgCode: parentOrgCode, Depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminQueryEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeRecordSearchResult>;
  public organisationPlanningAdminQueryEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminQueryEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeRecordSearchResult>>;
  public organisationPlanningAdminQueryEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminQueryEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeRecordSearchResult>>;
  public organisationPlanningAdminQueryEmployeeRecords(
    requestParameters?: OrganisationPlanningAdminQueryEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQueryEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrganisationId: requestParameters?.organisationId,
        OrganisationChartId: requestParameters?.organisationChartId,
        OriginOrganisationChartId: requestParameters?.originOrganisationChartId,
        Gid: requestParameters?.gid,
        Lastname: requestParameters?.lastname,
        Firstname: requestParameters?.firstname,
        OrgCode: requestParameters?.orgCode,
        Gids: requestParameters?.gids,
        OrgCodes: requestParameters?.orgCodes,
        PlacesOfAction: requestParameters?.placesOfAction,
        AssignmentStates: requestParameters?.assignmentStates,
        Search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryFieldValuesOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public organisationPlanningAdminQueryFieldValuesOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public organisationPlanningAdminQueryFieldValuesOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public organisationPlanningAdminQueryFieldValuesOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const organisationChartId = requestParameters?.organisationChartId;
    this.checkRequired('organisationPlanningAdminQueryFieldValuesOrganisationRecords', {
      simulationId,
      organisationChartId
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        OrgType: requestParameters?.orgType,
        OrgClass: requestParameters?.orgClass,
        OrgUnit: requestParameters?.orgUnit,
        OrgLevel: requestParameters?.orgLevel,
        OrgLevels: requestParameters?.orgLevels,
        OrganisationChartId: organisationChartId,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryFieldValuesOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public organisationPlanningAdminQueryFieldValuesOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public organisationPlanningAdminQueryFieldValuesOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public organisationPlanningAdminQueryFieldValuesOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryFieldValuesOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const organisationChartId = requestParameters?.organisationChartId;
    const chartId = requestParameters?.chartId;
    this.checkRequired('organisationPlanningAdminQueryFieldValuesOrganisations', { organisationChartId, chartId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        OrgType: requestParameters?.orgType,
        OrgName: requestParameters?.orgName,
        OrgUnit: requestParameters?.orgUnit,
        OrgClass: requestParameters?.orgClass,
        OrgLevels: requestParameters?.orgLevels,
        OrganisationChartId: organisationChartId,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationChartRecord>;
  public organisationPlanningAdminQueryOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationChartRecord>>;
  public organisationPlanningAdminQueryOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationChartRecord>>;
  public organisationPlanningAdminQueryOrganisationChartRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQueryOrganisationChartRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-charts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationChart>;
  public organisationPlanningAdminQueryOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationChart>>;
  public organisationPlanningAdminQueryOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationChart>>;
  public organisationPlanningAdminQueryOrganisationCharts(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordOriginsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationRecordOrigin>>;
  public organisationPlanningAdminQueryOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordOriginsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationRecordOrigin>>>;
  public organisationPlanningAdminQueryOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordOriginsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationRecordOrigin>>>;
  public organisationPlanningAdminQueryOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordOriginsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const organisationChartId = requestParameters?.organisationChartId;
    const parentOrgCode = requestParameters?.parentOrgCode;
    this.checkRequired('organisationPlanningAdminQueryOrganisationRecordOrigins', {
      simulationId,
      organisationChartId,
      parentOrgCode
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations/origins`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrganisationChartId: organisationChartId, ParentOrgCode: parentOrgCode, Depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationRecord>>;
  public organisationPlanningAdminQueryOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationRecord>>>;
  public organisationPlanningAdminQueryOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationRecord>>>;
  public organisationPlanningAdminQueryOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const organisationChartId = requestParameters?.organisationChartId;
    const parentOrgCode = requestParameters?.parentOrgCode;
    this.checkRequired('organisationPlanningAdminQueryOrganisationRecords', {
      simulationId,
      organisationChartId,
      parentOrgCode
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { OrganisationChartId: organisationChartId, ParentOrgCode: parentOrgCode, Depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationPlanningOrganisationsOrganisation>>;
  public organisationPlanningAdminQueryOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationPlanningOrganisationsOrganisation>>>;
  public organisationPlanningAdminQueryOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationPlanningOrganisationsOrganisation>>>;
  public organisationPlanningAdminQueryOrganisations(
    requestParameters?: OrganisationPlanningAdminQueryOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    const parentOrgCode = requestParameters?.parentOrgCode;
    this.checkRequired('organisationPlanningAdminQueryOrganisations', { chartId, parentOrgCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { ParentOrgCode: parentOrgCode, Depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryParentsOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordOriginsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationRecordOrigin>>;
  public organisationPlanningAdminQueryParentsOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordOriginsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationRecordOrigin>>>;
  public organisationPlanningAdminQueryParentsOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordOriginsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationRecordOrigin>>>;
  public organisationPlanningAdminQueryParentsOrganisationRecordOrigins(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordOriginsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQueryParentsOrganisationRecordOrigins', { id, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/origins/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryParentsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationRecord>>;
  public organisationPlanningAdminQueryParentsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationRecord>>>;
  public organisationPlanningAdminQueryParentsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationRecord>>>;
  public organisationPlanningAdminQueryParentsOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminQueryParentsOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQueryParentsOrganisationRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQueryPositionRecords(
    requestParameters?: OrganisationPlanningAdminQueryPositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeePositionRecord>;
  public organisationPlanningAdminQueryPositionRecords(
    requestParameters?: OrganisationPlanningAdminQueryPositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeePositionRecord>>;
  public organisationPlanningAdminQueryPositionRecords(
    requestParameters?: OrganisationPlanningAdminQueryPositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeePositionRecord>>;
  public organisationPlanningAdminQueryPositionRecords(
    requestParameters?: OrganisationPlanningAdminQueryPositionRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQueryPositionRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrganisationId: requestParameters?.organisationId,
        OrganisationChartId: requestParameters?.organisationChartId,
        Title: requestParameters?.title,
        OrgCode: requestParameters?.orgCode,
        ParentOrgCode: requestParameters?.parentOrgCode,
        OrgCodes: requestParameters?.orgCodes,
        ParentOrgCodes: requestParameters?.parentOrgCodes,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQuerySimulationSettings(
    requestParameters?: OrganisationPlanningAdminQuerySimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSimulationSettings>;
  public organisationPlanningAdminQuerySimulationSettings(
    requestParameters?: OrganisationPlanningAdminQuerySimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSimulationSettings>>;
  public organisationPlanningAdminQuerySimulationSettings(
    requestParameters?: OrganisationPlanningAdminQuerySimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSimulationSettings>>;
  public organisationPlanningAdminQuerySimulationSettings(
    requestParameters?: OrganisationPlanningAdminQuerySimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminQuerySimulationSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminQuerySimulations(
    requestParameters?: OrganisationPlanningAdminQuerySimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationPlanningSimulationsSimulation>;
  public organisationPlanningAdminQuerySimulations(
    requestParameters?: OrganisationPlanningAdminQuerySimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationPlanningSimulationsSimulation>>;
  public organisationPlanningAdminQuerySimulations(
    requestParameters?: OrganisationPlanningAdminQuerySimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationPlanningSimulationsSimulation>>;
  public organisationPlanningAdminQuerySimulations(
    requestParameters?: OrganisationPlanningAdminQuerySimulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Title: requestParameters?.title,
        SimulationState: requestParameters?.simulationState,
        IsArchived: requestParameters?.isArchived,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminUpdateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminUpdateJobAssignmentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<JobAssignmentRecord>;
  public organisationPlanningAdminUpdateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminUpdateJobAssignmentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<JobAssignmentRecord>>;
  public organisationPlanningAdminUpdateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminUpdateJobAssignmentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<JobAssignmentRecord>>;
  public organisationPlanningAdminUpdateJobAssignmentRecords(
    requestParameters?: OrganisationPlanningAdminUpdateJobAssignmentRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminUpdateJobAssignmentRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/job-assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateJobAssignmentRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminUpdateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationRecord>;
  public organisationPlanningAdminUpdateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationRecord>>;
  public organisationPlanningAdminUpdateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationRecord>>;
  public organisationPlanningAdminUpdateOrganisationRecords(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminUpdateOrganisationRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisationRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminUpdateOrganisations(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfUpdateOrganisationMetadata>;
  public organisationPlanningAdminUpdateOrganisations(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfUpdateOrganisationMetadata>>;
  public organisationPlanningAdminUpdateOrganisations(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfUpdateOrganisationMetadata>>;
  public organisationPlanningAdminUpdateOrganisations(
    requestParameters?: OrganisationPlanningAdminUpdateOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const chartId = requestParameters?.chartId;
    this.checkRequired('organisationPlanningAdminUpdateOrganisations', { id, chartId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationPlanningAdminUpdatePositionRecords(
    requestParameters?: OrganisationPlanningAdminUpdatePositionRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRecord>;
  public organisationPlanningAdminUpdatePositionRecords(
    requestParameters?: OrganisationPlanningAdminUpdatePositionRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRecord>>;
  public organisationPlanningAdminUpdatePositionRecords(
    requestParameters?: OrganisationPlanningAdminUpdatePositionRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRecord>>;
  public organisationPlanningAdminUpdatePositionRecords(
    requestParameters?: OrganisationPlanningAdminUpdatePositionRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('organisationPlanningAdminUpdatePositionRecords', { id, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/positions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRecord,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishSimulations(
    requestParameters?: PublishSimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPublishingMetadata>;
  public publishSimulations(
    requestParameters?: PublishSimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPublishingMetadata>>;
  public publishSimulations(
    requestParameters?: PublishSimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPublishingMetadata>>;
  public publishSimulations(requestParameters?: PublishSimulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('publishSimulations', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.simulationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAssignedEmployeesJobAssignmentRecords(
    requestParameters?: QueryAssignedEmployeesJobAssignmentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeRecordSearchResult>;
  public queryAssignedEmployeesJobAssignmentRecords(
    requestParameters?: QueryAssignedEmployeesJobAssignmentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeRecordSearchResult>>;
  public queryAssignedEmployeesJobAssignmentRecords(
    requestParameters?: QueryAssignedEmployeesJobAssignmentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeRecordSearchResult>>;
  public queryAssignedEmployeesJobAssignmentRecords(
    requestParameters?: QueryAssignedEmployeesJobAssignmentRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryAssignedEmployeesJobAssignmentRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/job-assignments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrganisationId: requestParameters?.organisationId,
        OrganisationChartId: requestParameters?.organisationChartId,
        Gid: requestParameters?.gid,
        Lastname: requestParameters?.lastname,
        Firstname: requestParameters?.firstname,
        OrgCode: requestParameters?.orgCode,
        Gids: requestParameters?.gids,
        OrgCodes: requestParameters?.orgCodes,
        Search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryChartPermissions(
    requestParameters?: QueryChartPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfChartPermission>;
  public queryChartPermissions(
    requestParameters?: QueryChartPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfChartPermission>>;
  public queryChartPermissions(
    requestParameters?: QueryChartPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfChartPermission>>;
  public queryChartPermissions(requestParameters?: QueryChartPermissionsParams, ...args: RequestArgs): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('queryChartPermissions', { chartId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployeeRecords(
    requestParameters?: QueryFieldValuesEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesEmployeeRecords(
    requestParameters?: QueryFieldValuesEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesEmployeeRecords(
    requestParameters?: QueryFieldValuesEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesEmployeeRecords(
    requestParameters?: QueryFieldValuesEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const fieldName = requestParameters?.fieldName;
    this.checkRequired('queryFieldValuesEmployeeRecords', { simulationId, fieldName });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { search: requestParameters?.search, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryParentsOrganisations(
    requestParameters?: QueryParentsOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationPlanningOrganisationsOrganisation>>;
  public queryParentsOrganisations(
    requestParameters?: QueryParentsOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationPlanningOrganisationsOrganisation>>>;
  public queryParentsOrganisations(
    requestParameters?: QueryParentsOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationPlanningOrganisationsOrganisation>>>;
  public queryParentsOrganisations(
    requestParameters?: QueryParentsOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const chartId = requestParameters?.chartId;
    this.checkRequired('queryParentsOrganisations', { id, chartId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { depth: requestParameters?.depth }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPermissionSettings(
    requestParameters?: QueryPermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPermissionSetting>;
  public queryPermissionSettings(
    requestParameters?: QueryPermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPermissionSetting>>;
  public queryPermissionSettings(
    requestParameters?: QueryPermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPermissionSetting>>;
  public queryPermissionSettings(
    requestParameters?: QueryPermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryPermissionSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permission-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Title: requestParameters?.title,
        RootOrgCode: requestParameters?.rootOrgCode,
        RootRecordOrgCode: requestParameters?.rootRecordOrgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPopulations(
    requestParameters?: QueryPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPopulation>;
  public queryPopulations(
    requestParameters?: QueryPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPopulation>>;
  public queryPopulations(
    requestParameters?: QueryPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPopulation>>;
  public queryPopulations(requestParameters?: QueryPopulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('queryPopulations', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/populations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Title: requestParameters?.title,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySimulationPermissions(
    requestParameters?: QuerySimulationPermissionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSimulationPermission>;
  public querySimulationPermissions(
    requestParameters?: QuerySimulationPermissionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSimulationPermission>>;
  public querySimulationPermissions(
    requestParameters?: QuerySimulationPermissionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSimulationPermission>>;
  public querySimulationPermissions(
    requestParameters?: QuerySimulationPermissionsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('querySimulationPermissions', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permissions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateManyPermissionSettings(
    requestParameters?: RecalculateManyPermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPermissionRecalculationMetadata>;
  public recalculateManyPermissionSettings(
    requestParameters?: RecalculateManyPermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPermissionRecalculationMetadata>>;
  public recalculateManyPermissionSettings(
    requestParameters?: RecalculateManyPermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPermissionRecalculationMetadata>>;
  public recalculateManyPermissionSettings(
    requestParameters?: RecalculateManyPermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('recalculateManyPermissionSettings', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permission-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateManyPopulations(
    requestParameters?: RecalculateManyPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationRecalculationMetadata>;
  public recalculateManyPopulations(
    requestParameters?: RecalculateManyPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationRecalculationMetadata>>;
  public recalculateManyPopulations(
    requestParameters?: RecalculateManyPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationRecalculationMetadata>>;
  public recalculateManyPopulations(
    requestParameters?: RecalculateManyPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('recalculateManyPopulations', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/populations`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculatePermissionSettings(
    requestParameters?: RecalculatePermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPermissionRecalculationMetadata>;
  public recalculatePermissionSettings(
    requestParameters?: RecalculatePermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPermissionRecalculationMetadata>>;
  public recalculatePermissionSettings(
    requestParameters?: RecalculatePermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPermissionRecalculationMetadata>>;
  public recalculatePermissionSettings(
    requestParameters?: RecalculatePermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('recalculatePermissionSettings', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/permission-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculatePopulations(
    requestParameters?: RecalculatePopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationRecalculationMetadata>;
  public recalculatePopulations(
    requestParameters?: RecalculatePopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationRecalculationMetadata>>;
  public recalculatePopulations(
    requestParameters?: RecalculatePopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationRecalculationMetadata>>;
  public recalculatePopulations(
    requestParameters?: RecalculatePopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('recalculatePopulations', { id, simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public removePopulationUsers(
    requestParameters?: RemovePopulationUsersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public removePopulationUsers(
    requestParameters?: RemovePopulationUsersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public removePopulationUsers(
    requestParameters?: RemovePopulationUsersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public removePopulationUsers(requestParameters?: RemovePopulationUsersParams, ...args: RequestArgs): Observable<any> {
    const populationId = requestParameters?.populationId;
    const userId = requestParameters?.userId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('removePopulationUsers', { populationId, userId, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/populations/${this.configuration.encodeParam({ name: 'populationId', value: populationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/users/${this.configuration.encodeParam({ name: 'userId', value: userId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePopulationEmployeeRecords(
    requestParameters?: SimulatePopulationEmployeeRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeRecordSearchResult>;
  public simulatePopulationEmployeeRecords(
    requestParameters?: SimulatePopulationEmployeeRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeRecordSearchResult>>;
  public simulatePopulationEmployeeRecords(
    requestParameters?: SimulatePopulationEmployeeRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeRecordSearchResult>>;
  public simulatePopulationEmployeeRecords(
    requestParameters?: SimulatePopulationEmployeeRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('simulatePopulationEmployeeRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyOrganisationChartRecords(
    requestParameters?: UpdateManyOrganisationChartRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public updateManyOrganisationChartRecords(
    requestParameters?: UpdateManyOrganisationChartRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public updateManyOrganisationChartRecords(
    requestParameters?: UpdateManyOrganisationChartRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public updateManyOrganisationChartRecords(
    requestParameters?: UpdateManyOrganisationChartRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateManyOrganisationChartRecords', { simulationId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/organisation-charts`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyOrganisationChartRecords,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOrganisationCharts(
    requestParameters?: UpdateOrganisationChartsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationChart>;
  public updateOrganisationCharts(
    requestParameters?: UpdateOrganisationChartsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationChart>>;
  public updateOrganisationCharts(
    requestParameters?: UpdateOrganisationChartsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationChart>>;
  public updateOrganisationCharts(
    requestParameters?: UpdateOrganisationChartsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const chartId = requestParameters?.chartId;
    this.checkRequired('updateOrganisationCharts', { chartId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/charts/${this.configuration.encodeParam({ name: 'chartId', value: chartId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisationChart,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePermissionSettings(
    requestParameters?: UpdatePermissionSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PermissionSetting>;
  public updatePermissionSettings(
    requestParameters?: UpdatePermissionSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PermissionSetting>>;
  public updatePermissionSettings(
    requestParameters?: UpdatePermissionSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PermissionSetting>>;
  public updatePermissionSettings(
    requestParameters?: UpdatePermissionSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('updatePermissionSettings', { simulationId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/permission-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePermissionSetting,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePopulations(
    requestParameters?: UpdatePopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Population>;
  public updatePopulations(
    requestParameters?: UpdatePopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Population>>;
  public updatePopulations(
    requestParameters?: UpdatePopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Population>>;
  public updatePopulations(requestParameters?: UpdatePopulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('updatePopulations', { simulationId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/populations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.populationsUpdatePopulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulationSettings(
    requestParameters?: UpdateSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationSettings>;
  public updateSimulationSettings(
    requestParameters?: UpdateSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationSettings>>;
  public updateSimulationSettings(
    requestParameters?: UpdateSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationSettings>>;
  public updateSimulationSettings(
    requestParameters?: UpdateSimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const id = requestParameters?.id;
    this.checkRequired('updateSimulationSettings', { simulationId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSimulationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulations(
    requestParameters?: UpdateSimulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationPlanningSimulationsSimulation>;
  public updateSimulations(
    requestParameters?: UpdateSimulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationPlanningSimulationsSimulation>>;
  public updateSimulations(
    requestParameters?: UpdateSimulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationPlanningSimulationsSimulation>>;
  public updateSimulations(requestParameters?: UpdateSimulationsParams, ...args: RequestArgs): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('updateSimulations', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/organisation-planning/admin/v1/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.organisationPlanningSimulationsUpdateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
